import { WidgetTypes, type WidgetType } from "legacy/constants/WidgetConstants";

const prefix = WidgetTypes.CUSTOM_WIDGET + ":";

export function isCustomComponentType(type: string): type is WidgetType {
  if (typeof type !== "string") {
    throw new Error(`type must be a string: ${JSON.stringify(type)}`);
  }
  return type.startsWith(prefix);
}
